import { render, staticRenderFns } from "./OrderItemListTable.vue?vue&type=template&id=368bb5c1&scoped=true&"
import script from "./OrderItemListTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemListTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemListTable.vue?vue&type=style&index=0&id=368bb5c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368bb5c1",
  null
  
)

export default component.exports